import { jsx as _jsx } from "react/jsx-runtime";
import { SvgCheck } from '../../index';
import { Tick } from './Tick';
export function CheckboxTick(props) {
    const handleClick = (e) => {
        props.onClick?.(e, { data: props.data });
    };
    return (_jsx(Tick, { type: props.isExclusive ? 'checkbox-exclusive' : 'checkbox', color: props.color, icon: _jsx(SvgCheck, {}), isHovered: props.isHovered, onClick: props.onClick && handleClick, children: _jsx("input", { type: 'checkbox', name: props.name, value: props.value, defaultChecked: props.isDefaultChecked, checked: props.isChecked, disabled: props.isDisabled, readOnly: !!props.onClick, onChange: props.onChange
                ? (e) => props.onChange?.(e, { data: props.data })
                : undefined, "aria-invalid": props.isInvalid, "data-test-id": props.testId ? `${props.testId}-input` : undefined }) }));
}
//# sourceMappingURL=CheckboxTick.js.map